export enum AssignDocumentErrorFields {
  FileName = 'fileName',
  SelectedFileType = 'selectedFileType',
  SelectedDocument = 'selectedDocument',
  SelectedYearMonth = 'selectedYearMonth',
}
